import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { DataTableColumn, DataTableComponent } from '@shared/components/data-table.component';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { ClientResponse } from '../../client.model';
import { ActionMenu } from "@shared/components/action-menu/action-menu";
import { useClientActionMenu } from "./client-action-menu-composable";

@Component({
  selector: 'client-table',
  imports: [DataTableComponent, ActionMenu, ...SharedMaterialUIModule],
  templateUrl: './client-table.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ClientTableComponent {
  protected readonly columns: DataTableColumn<ClientResponse>[] = [
    {
      id: 'name',
      header: 'Name',
      value: (client) => client.name,
      cellClass: 'px-3 py-3 font-medium',
    },
    {
      id: 'status',
      header: 'Status',
      value: (client) => (client.isActive ? 'Active' : 'Inactive'),
      cellClass: 'px-3 py-3',
    },
  ];

  readonly clients = input<ClientResponse[]>([]);
  readonly loading = input(false);

  readonly canDeactivate = input(false);
  readonly canActivate = input(false);

  readonly actionClientId = input<string | null>(null);

  readonly toggled = output<ClientResponse>();
  readonly actionMenuItems = useClientActionMenu().clientActionMenuItems;
  readonly actions: Record<string, any> = {
    'toggled': this.toggled,
  };
}